import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  groupName: Yup.string().max(25).required("Group Name is required."),
});

export default validationSchema;
